/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewPrivacyCriticalTrackingTech = {
    GoogleAnalytics: 'Google Analytics',
    MetaPixel: 'Meta Pixel',
    LinkedInInsightTag: 'LinkedIn Insight Tag',
    TikTokPixel: 'TikTok Pixel',
    XPixel: 'X Pixel',
    PinterestTag: 'Pinterest Tag',
    Heap: 'Heap',
    FullStory: 'FullStory',
    MicrosoftClarity: 'Microsoft Clarity',
    Hotjar: 'Hotjar',
    HubSpot: 'HubSpot'
} as const;
export type CRSFSecReviewPrivacyCriticalTrackingTech = typeof CRSFSecReviewPrivacyCriticalTrackingTech[keyof typeof CRSFSecReviewPrivacyCriticalTrackingTech];


export function CRSFSecReviewPrivacyCriticalTrackingTechFromJSON(json: any): CRSFSecReviewPrivacyCriticalTrackingTech {
    return CRSFSecReviewPrivacyCriticalTrackingTechFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyCriticalTrackingTechFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyCriticalTrackingTech {
    return json as CRSFSecReviewPrivacyCriticalTrackingTech;
}

export function CRSFSecReviewPrivacyCriticalTrackingTechToJSON(value?: CRSFSecReviewPrivacyCriticalTrackingTech | null): any {
    return value as any;
}

